<template>
    <div class="oppo-batch-create-page-wrap">
        <div class="create_page_header" :style="{width: fixWidth}">
            <el-button type="text" icon="el-icon-back" :style="{fontSize: '14px'}" @click="cancelCreate" v-matomo="{behaviorCategory: 'OPPO(批量创建)',  name: '批量创建('+getBehaviorName(curStep)+'-取消创建)' }">取消创建</el-button>
            <span class="text pl10 pr10 font14px">|</span>
            <span class="text pr10 font14px">批量创建</span>

            <el-button v-if="curStep>1" type="default" size="mini" ghost class="action-btn" @click="toLastStep" v-matomo="{behaviorCategory: 'OPPO(批量创建)',  name: '批量创建('+getBehaviorName(curStep)+'-返回上一步)' }">返回上一步</el-button>
            <el-button v-if="curStep<3" type="primary" size="mini" ghost class="action-btn" :loading="nextStepLoading" @click="toNextStep" v-matomo="{behaviorCategory: 'OPPO(批量创建)',  name: '批量创建('+getBehaviorName(curStep)+'-下一步)' }">下一步</el-button>
            <el-button slot="reference" v-if="curStep==3" type="primary" size="mini" ghost class="action-btn" :loading="previewLoading" @click="previewIdeaInfo" v-matomo="{behaviorCategory: 'OPPO(批量创建)',  name: '批量创建('+getBehaviorName(curStep)+'-生成预览)' }">生成预览</el-button>
            <el-button v-if="curStep==4" type="primary" size="mini" ghost class="action-btn" :loading="submitLoading" @click="handleSubmit" v-matomo="{behaviorCategory: 'OPPO(批量创建)',  name: '批量创建(生成预览-提交)' }">提交</el-button>

        </div>

        <div class="ml40 mr40">
            <el-alert
                class="alert-border"
                :closable="false"
                show-icon
                type="warning">
                <p slot="title" class="text-color-333 font12px">
                    <span class="text-bold text-color-error">重要提示：</span>
                    受媒体限制，若<span class="text-bold">需要设置定向</span>，请<span class="text-bold">选择定向包使用</span>，勿调用未使用定向包的计划，未使用定向包会导致调用和创建的广告组<span class="text-bold">统一定向</span>（修改任何一个定向条件，其他的广告组都会改变）。
                </p>
            </el-alert>
        </div>
        <div class="create_page_body">
        <div class="step-bar mt20">
            <el-steps :active="curStep" process-status="process" align-center>
                <el-step title="调用计划"></el-step>
                <el-step title="规则配置"></el-step>
                <el-step title="上传创意"></el-step>
                <el-step title="生成预览"></el-step>
            </el-steps>
        </div>

        <div class="form-wrap ml60">
            <div class="step-form-wrap">
                <div v-show="curStep==1">
                    <steps-plan ref="stepsPlan_1"></steps-plan>

                </div>
                <div v-show="curStep==2">
                    <steps-rule ref="stepsRule" :recourse="this.formItem" :pageFuncNames="pageFuncNames" @changeLoading="changeLoading"></steps-rule>
                </div>

                <el-form ref="form3" v-show="curStep==3" label-width="120px">
                     <!--

                     -->
                    <UploadIdea
                            :is-show="curStep==3"
                            :app_list="formItem.app_list"
                            :plan-id="formItem.plan_id"
                            :task-id="taskId"
                            :extension="extensionType+''"
                            ref="UploadIdea"
                        />
                </el-form>

                <div v-show="curStep==4">
                    <div class="ml100">
                        <IdeaResult ref="ideaList" :task-id="taskId" :form-item="formItem" :date-type="dateType" :app-data="curAppData" :range="range" :range1="range1"/>
                    </div>
                </div>

            </div>
        </div>


        </div>
    </div>
</template>

<script>
    import CheckPlanModal from '../modal/checkPlanModal';
    import AdGroupItem from '../components/adGroupItem';
    import MaterialItem from '../components/materialItem';
    import DelayButton from '../components/delayButton';
    import IdeaSpecsPreview from '../components/ideaSpecsPreview';
    import IdeaResult from '../components/ideaResult';
    import StepsPlan from "../components/stepsPlan.vue";
    import stepsRule from "../components/stepsRule.vue";
    import API from '@/api/marketManage/oppoBatch';
    import utils from '@/libs/utils.js';
    import getMediaInfo from '@/libs/media_old.js';
    import dayjs from 'dayjs';
    import UploadIdea from '../components/uploadIdea'
     import { tipModal } from '../modal/index';
    export default {
        name: "ConfigPage",
        props:{
            pageFuncNames:Array,
        },
        components:{
            StepsPlan,
            stepsRule,
            CheckPlanModal,
            AdGroupItem,
            MaterialItem,
            DelayButton,
            IdeaSpecsPreview,
            IdeaResult,
            UploadIdea
        },
        data(){
            let todayStr = dayjs().format('YYYY-MM-DD');
            const validatePlan = (rule, value, callback) => {
                if (!this.isCheckedPlanInfo) {
                    callback(new Error('请核实计划信息'));
                } else {
                    callback();
                }
            };
            const validateQuick = (rule, value, callback) => {
                if (!this.isCheckedQuick) {
                    callback(new Error('请核实快应用信息'));
                } else {
                    callback();
                }
            };
            return {
                formStepItem1:{
                    account_id:'',
                    extension_type: '2', // 选择计划
                    plan_id:[],
                    target_account:[],
                },

                taskId:'',

                fixWidth: '1000px',
                curStep: 1,
                formItem:{
                    account_id:'',
                    plan_id:[],
                    target_account:[],
                    app_list:[],
                    taskId: '',
                    plan_status:'1',
                    default_second_stage:'1',
                    batch_rules:'2',
                    // idea_upload_config:'2',
                    replace_name_status:'1',
                    // instant_app_url: '',
                    // page_select:'',
                    // page_url:''
                },
                dateType:'1',
                range:'',
                range1:[],

                formQuick:{
                    instant_app_url: ''
                },
                extension_flow:'', // 快应用  推广流量
                flow_scene: '', //快应用  流量场景
                quickInfo: {},
                isCheckedQuick: false,
                isCheckedQuickLoading:false,
                sub_list_type: 'content',  //打底网址 下拉与输入
                sub_list:[],
                quickUrlList:[], //打底网址 下拉option
                appList:[],

                step1Loading:false,
                accountLoading:false,
                updatePlanLoading:false,
                accountList:[],
                planList:[],
                targetAccountList:[],
                isCheckedPlanInfo:false,
                checkPlanLoading:false,
                hasGroupTargetId:false,
                targetAccountLoading:false,
                form1Rules:{
                    account_id:[
                        { required: true, message: '请选择账户', trigger: 'blur' }
                    ],
                    plan_id:[
                        { required: true, message: '请选择计划' },
                    ],
                    is_check_plan:[
                        { validator: validatePlan },
                    ],
                    target_account:[
                        { type: 'array', required: true, message: '请选择目标账户', trigger: 'change' }
                    ],
                },
                form2Rules:{
                    batch_rules:[
                        { required: true, message: '创意上传规则不能为空' },
                    ],
                    app_id:[
                        { required: true, message: '请选择投放产品', trigger: 'blur' }
                    ]
                },
                formQuickRules:{
                    app_id:[
                        { required: true, message: '快应用ID不能为空', trigger: 'blur' },
                    ],
                    instant_app_url:[
                        { required: true, message: '快应用直达链接不能为空', trigger: 'blur' }
                    ],
                    page_url: [
                        { required: true, message: '必填项不可为空', trigger: 'change' }
                    ],
                    is_check_quick:[
                        { validator: validateQuick },
                    ],
                },

                dateOptions:{
                    firstDayOfWeek: 1,
                    disabledDate (date) {
                        return date && date.valueOf() < Date.now() - 1000*60*60*24;
                    }
                },
                sourceAppId:'',         // 记录源appId
                planUploadConfig:[],        // 存储所有的上传规格
                uploadStore:[
                    // {"name":"01JBBY200115W2DF.mp4","type":"video/mp4","size":22761857,"key":0,"ext":"mp4","md5":"e7ec415274f7d5b2e888efcf44c35e8b","sha1":"adc52d263e685b36fa89cec00f34bd0e68c7d38a","savename":"01JBBY200115W2DF.mp4","savepath":"20230814/64d99fd7e28a2/","filePath":"/batch/20230814/64d99fd7e28a2/01JBBY200115W2DF.mp4","fullFilePath":"http://download.wmgm.gm825.net/cpd/developmet/plat/batch/20230814/64d99fd7e28a2/01JBBY200115W2DF.mp4"}
                ],         // 缓存上传成功的素材
                submitLoading:false,
                fullscreenLoading: false,  //上传loading
                planNotifyTip:null,
                previewLoading:false,
                nextStepLoading:false,
                extensionType: 2, // 3 表示快应用  小游戏
            }
        },
        computed:{
            fileConfigs(){
                let allConfigs = [];
                let planUploadConfig = this.planUploadConfig||[];
                planUploadConfig.forEach(item=>{
                    let materialInfoList = item.material_info||[];
                    allConfigs = allConfigs.concat(materialInfoList);
                });
                return allConfigs;
            },
            fileAccept(){
                let allFormats = this.fileConfigs.map(item=>item.conf_format).join('/').toLocaleLowerCase();
                let results = [];
                if(allFormats.includes('png')){
                    results.push("image/png");
                }
                if(allFormats.includes('jpeg')||allFormats.includes('jpg')){
                    results.push("image/jpeg");
                }
                if(allFormats.includes('gif')){
                    results.push("image/gif");
                }
                if(allFormats.includes('mp4')){
                    results.push("video/mp4");
                }
                return results.join(',');
            },
            isNeedTipLast(){
                let needTip = false;
                if(this.curStep == 1){
                    needTip = false;
                }
                if(this.curStep == 2&&this.formItem.plan_status!='1'||this.formItem.default_second_stage!='1'||this.dateType!='1'||(this.dateType=='1'&&!dayjs(this.range).isSame(dayjs(),'day'))){
                    needTip = true;
                }
                if(this.curStep == 3&&this.uploadStore.length>0){
                    needTip = true;
                }
                if(this.curStep == 4){
                    needTip = false;
                }
                return needTip;
            },
            curHour(){
                return dayjs().hour();
            },
            curAppData(){
                if(!this.formItem.app_id) return {};
                return this.appList.find(item=>item.app_id==this.formItem.app_id)||{};
            },
            groupStartDate(){
                if(this.dateType=='1') return this.range;
                if(this.dateType=='2') return this.range1[0];
                return "";
            },
            todayStr(){
                return dayjs().format('YYYY-MM-DD');
            },
        },
        mounted(){
            this.getFixWidth()
            window.addEventListener('resize', this.getFixWidth)
            window.onbeforeunload = function(){
                return "确定要离开吗？系统可能不会保存您所做的更改";
            }
        },
        methods:{
            getFixWidth(){
                let $createBody = document.querySelector('.create_page_body');
                if(!$createBody) return ;
                this.fixWidth = `${$createBody.clientWidth + 20}px`;
            },
            resetForm(){
                this.curStep = 1;
                this.uploadStore = [];      // 清空上传的文件缓存；
            },

            getBehaviorName(step){
                // console.log('getBehaviorName',this.curStep,step);
                if(step == 1) return '第一步';
                if(step == 2) return '第二步';
                if(step == 3) return '第三步';
                if(step == 4) return '生成预览';
            },
            taskPreviewInfo(){
                API.taskPreviewInfo({
                    task_id:this.taskId,
                }).then(res=>{
                    console.log('taskPreviewInfo',res);
                },err=>{
                    console.log('taskPreviewInfo err',err);
                })
            },
            taskPreviewIdeaList(){
                API.taskPreviewIdeaList({
                    task_id:this.taskId,
                }).then(res=>{
                    console.log('taskPreviewIdeaList',res);
                },err=>{
                    console.log('taskPreviewIdeaList err',err);
                })
            },
            handleSubmit(type){
                this.submitLoading = true;
                API.saveTask({
                    task_id:this.taskId,
                    plan_status:this.formItem.plan_status,
                    default_second_stage:this.formItem.default_second_stage,
                    group_start_date:this.dateType=='1'?'':utils.formatDate(this.range1[0]),   //无
                    group_end_date:this.dateType=='1'?'':utils.formatDate(this.range1[1]),     //无
                    idea_upload_config:this.formItem.idea_upload_config,
                }).then(res=>{
                    this.submitLoading = false;
                    this.$message.success(res.info||'');

                    if(type=='recreate'){
                        this.curStep = 1;
                        this.resetStep1Data();
                        this.resetStep2Data();
                        this.resetStep3Data();
                    }else{
                        this.toListPage();
                        this.$emit('update');
                    }
                },err=>{
                    console.log('handleSubmit err',err);
                    this.submitLoading = false;
                    this.$notify.error({
                        title: '提交失败',
                        message: err.info,
                        duration: 0
                    });
                })
            },

            async previewIdeaInfo(){
                const selectData = this.$refs.UploadIdea.getParamsData();
                const params = {
                    task_id: this.taskId, // this.taskId, //789
                    target_account: this.formItem.target_account.toString(), //this.formItem.account_id.toString(),// 1000109480
                    app_id: this.formItem.app_list.map(v=>v.app_id),// this.formItem.app_list.map(v=>v.app_id),//30434017
                    extension_type: this.extensionType,//this.extensionType,//3
                    replace_name_status: this.formItem.replace_name_status,
                    plans: selectData
                };
                if (!this.getGroupvalidata()) {
                    return;
                }
                try {
                    this.previewLoading = true;
                    const resData = await API.taskPreview(params);
                    let adGroupCreateNum = resData.adgroup_create_num||[];
                    let planCreateNum = resData.plan_create_num||[];
                    if(adGroupCreateNum.length>0){
                        let htmlStr = `<div style="max-height: 250px;overflow: auto;"><p>以下目标账户已有广告组加上此次需要创建的广告组数量已经 <span class="text-color-error">超过500条</span>，请确认是否有权限可继续创建，以免造成重复工作！</p>`;

                        adGroupCreateNum.forEach(item=>{
                            htmlStr += `<p class="font12px clear-both"> <span class="fl">${item.name}</span> <span class="fr text-color-error">${item.num}条</span> </p>`;
                        });
                        htmlStr += `</div>`;
                        this.$confirm(htmlStr,'提示',{
                            confirmButtonText: '可继续创建',
                            cancelButtonText: '关闭提示',
                            type: 'warning',
                            dangerouslyUseHTMLString: true,
                            customClass:'wide-confirm-box-550',
                        }).then(()=>{
                            console.log('继续');
                            if(planCreateNum.length>0){
                                let htmlStr = `<div style="max-height: 250px;overflow: auto;"><p>以下目标账户已有计划数量 <span class="text-color-error">超过50条</span>，请确认是否有权限可继续创建，以免造成重复工作！</p>`;
                                planCreateNum.forEach(item=>{
                                    htmlStr += `<p class="font12px clear-both"> <span class="fl">${item.name}</span> <span class="fr text-color-error">${item.num}条</span> </p>`;
                                });
                                htmlStr += `</div>`;
                                this.$confirm(htmlStr,'提示',{
                                    confirmButtonText: '可继续创建',
                                    cancelButtonText: '取消创建',
                                    type: 'warning',
                                    dangerouslyUseHTMLString: true,
                                    customClass:'wide-confirm-box-550',
                                }).then(()=>{
                                    this.curStep++;
                                    this.$refs.ideaList.getIdeaInfo();
                                }).catch(()=>{
                                    console.log('取消');
                                })
                            }else{
                                this.curStep++;
                                this.$refs.ideaList.getIdeaInfo();
                            }
                        }).catch(()=>{
                            console.log('取消');
                        })
                    }else{
                        if(planCreateNum.length>0){
                            let htmlStr = `<div style="max-height: 250px;overflow: auto;"><p>以下目标账户已有计划数量 <span class="text-color-error">超过50条</span>，请确认是否有权限可继续创建，以免造成重复工作！</p>`;
                            planCreateNum.forEach(item=>{
                                htmlStr += `<p class="font12px clear-both"> <span class="fl">${item.name}</span> <span class="fr text-color-error">${item.num}条</span> </p>`;
                            });
                            htmlStr += `</div>`;
                            this.$confirm(htmlStr,'提示',{
                                confirmButtonText: '可继续创建',
                                cancelButtonText: '取消创建',
                                type: 'warning',
                                dangerouslyUseHTMLString: true,
                                customClass:'wide-confirm-box-550',
                            }).then(()=>{
                                this.curStep++;
                                this.$refs.ideaList.getIdeaInfo();
                            }).catch(()=>{
                                console.log('取消');
                            })
                        }else{
                            this.curStep++;
                            this.$refs.ideaList.getIdeaInfo();
                        }
                    }
                } catch (err) {
                    console.log('预览发生错误', err);
                    let errData = err.data||[];
                    if(err.code==0&&errData.length>0){
                        let text = errData.map(item=>`<p style="text-align: initial;">${item}</p>`).join('')
                        this.$notify.error({
                            title: err.info||'请求失败',
                            dangerouslyUseHTMLString: true,
                            message: text,
                            duration: 0
                        });
                    }else{
                        this.$message.error(err.info||'操作失败');
                    }
                    // this.$message.error(error.info || error.message)
                } finally {
                    this.previewLoading = false;
                }
            },
            getGroupvalidata() {
                let isequel = true;
                let totalData = {};
                let initTotalData = {};
                this.$bus.$emit('getTotalNum', (total, initData,  applist)=> {
                    totalData = total;
                    initTotalData = initData;
                    const errList = [];
                    const package_name_list =
                    applist.map(v=> {
                        const package_name = v.package_name;
                        if (!total[package_name]) {
                            errList.push(v.app_name)
                        };
                        return package_name;
                    });
                    if (errList.length) {
                         isequel = false;
                        tipModal({
                            props: {
                                tip: '以下产品素材为空，请检查！',
                                list: {
                                    "": errList
                                }
                            }
                        })
                    }else {
                        const deep = package_name_list.every(appId=>totalData[appId] === initTotalData[appId]);
                        if (deep) {
                            isequel = true
                        }else {
                            this.$message.error('素材存在必填项，请检查')
                            isequel = false
                        }
                    }
                });
                if(isequel) {
                    return isequel
                }
                return isequel
            },
            cancelCreate(){
                if(this.curStep == 1&&!this.formItem.account_id){
                    this.toListPage();
                }else{
                    this.$confirm('取消后不会保存当前内容，确认要取消吗？','温馨提示',{
                        confirmButtonText: '确认取消',
                        cancelButtonText: '关闭',
                        type: 'warning',
                    }).then(()=>{
                        this.toListPage();
                    })
                }
            },
            toListPage(){
                this.$emit('changePage','list');
                this.resetForm();
            },
            toLastStep(){
                if(this.curStep==4){
                    this.$confirm('如果已经手动修改了内容，不会保留，下次生成预览时需要再次修改，请知晓！','温馨提示',{
                        confirmButtonText: '确认',
                        cancelButtonText: '关闭',
                        type: 'warning',
                    }).then(()=>{
                        this.curStep--;
                    })

                }else{
                    this.curStep--;
                }
                window.scrollTo({
                    top: 0,
                    behavior: 'smooth'
                });
            },
            changeLoading() {
                this.nextStepLoading = false
            },
            toNextStep(){

                if(this.curStep==1){
                    this.nextStepLoading = true
                    this.$refs.stepsPlan_1.validateSteps().then(res=>{
                        console.log('res', res);


                        let new_result = `${res.account_id}_${res.target_account.join()}_${res.extension_type.toString()}`

                        let cache_form = `${this.formItem.account_id}_${this.formItem.target_account.join()}_${this.extensionType ? this.extensionType.toString() : ''}`



                        this.formItem.account_id = res.account_id
                        this.formItem.plan_id = res.plan_id
                        this.formItem.target_account = res.target_account
                        this.formItem.taskId = res.task_id

                        this.taskId = res.task_id;
                        this.extensionType = res.extension_type;

                        this.curStep++;
                        setTimeout(()=>{
                            if(this.formItem.account_id != '' && this.formItem.plan_id.length > 0 && this.formItem.target_account.length > 0 && cache_form != new_result) {
                                // 不相同  清空后续
                                this.$refs.stepsRule.clearData(this.extensionType);
                                this.nextStepLoading = false
                            }else{
                                this.$refs.stepsRule.getUrlList(this.extensionType);
                            }
                        }, 200)

                    }, err=>{
                        console.log('err',err);
                        this.nextStepLoading = false
                    }).finally(()=>{
                        // setTimeout(()=>{
                        //     this.nextStepLoading = false
                        // }, 2000)
                        if(this.extensionType != '3') {
                            this.nextStepLoading = false
                        }
                    })

                }else if(this.curStep==2) {
                    this.nextStepLoading = true
                    this.$refs.stepsRule.validateSteps().then(res=>{
                        this.formItem.app_list = res.app_list
                        this.formItem.plan_status = res.formItem.plan_status
                        this.formItem.default_second_stage = res.formItem.default_second_stage
                        this.formItem.replace_name_status = res.formItem.replace_name_status
                        this.dateType = res.dateType
                        this.range1 = res.range1
                        console.log(this.range1)
                        this.range = res.range

                        this.curStep++;
                    }).finally(()=>{
                        this.nextStepLoading = false
                    })
                }else{
                    this.curStep++;
                }

                window.scrollTo({
                    top: 0,
                    behavior: 'smooth'
                });

            },
        },
        beforeDestroy() {
            window.onbeforeunload = null;
            window.removeEventListener('resize', this.getFixWidth)
        }
    }
</script>

<style lang="scss" scoped>
    ::v-deep .el-step__title{
        font-size: 12px;
    }
    .title-group{
        font-size: 14px;
        margin-bottom: 20px;
    }
    .action-btn{
        width: 120px;
        margin: 0 20px;
    }
    .tab-nav-btn{
        width: 150px;
    }
    .ad-group-items{
        display: flex;
        flex-wrap: wrap;
        line-height: 16px;
    }

    .material-content-wrap{
        margin-top: 20px;
        display: flex;
        flex-wrap: wrap;
        min-height: 500px;
        .left-con{
            /*max-width: 1200px;*/
            height: 100%;
            margin-right: 20px;
            width: calc(100% - 350px);
        }

        .right-con{
            height: 100%;
            width: 330px;
            padding: 15px 10px;
            border-radius: 5px;
            box-shadow: 0 2px 4px rgba(0, 0, 0, .12), 0 0 6px rgba(0, 0, 0, .04);
            background-color: #f2f2f2;
            border:1px solid #d7d7d7;
            flex: 1;
        }
    }

    //::v-deep .upload-box .el-upload {
    //    width: 100%;
    //    .el-upload-dragger{
    //        width: 100%;
    //        height: 80px;
    //        .el-icon-upload{
    //            font-size: 40px;
    //            margin: 0 auto;
    //            line-height: 40px;
    //            color: #409EFF;
    //        }
    //        .el-upload__text{
    //            font-size: 12px;
    //        }
    //    }
    //}
    //
    //.upload-box .upload-loading-wrap{
    //    position: absolute;
    //    z-index: 2;
    //    right: 20px;
    //    top: 10px;
    //    cursor: pointer;
    //    color: #409EFF;
    //    .el-icon-loading{
    //        font-size: 30px;
    //    }
    //}
    .stop-upload-wrap{
        position: absolute;
        right: 10px;
        top: 45px;
    }

    .material-table-wrap{
        border: solid 1px #ccc;
        h3{
            border-bottom: solid 1px #ccc;
        }
        .table-header-self p{
            line-height: 12px;
            font-weight: normal;
        }
        ::v-deep .el-table__header .el-table__cell{
            padding: 3px 0;
        }

    }

    .oppo-batch-create-page-wrap{
        padding-top: 50px;
        background-color: #fff;
        min-height:  calc(100vh);
    }
    .create_page_header{
        background-color: #fff;
        padding: 2px 8px;
        display: flex;
        align-items: center;
        position: fixed;
        top: 52px;
        z-index: 30;
        box-shadow: 0 1px 2px #d9d9d9;
        transform: translateX(-10px);
        .text {
            display:inline-block;
            line-height: 32px;
        }
    }
    .img-holder{
        height: 80px;
        width: 100%;
        background: #eee;
        border: dashed 1px #ccc;
    }

    .text-color-333{
        color: #333;
    }
    .alert-border{
        border: solid 1px #ffda57;
    }

    .mini-switch{
        transform: scale(0.8);
    }
    .quiok-con{
        display: flex;
        align-items: center;
    }
    .quiok{
        display: flex;
        align-items: center;
        margin-left: 20px;
        img{
            width: 50px;
            margin-right: 8px;
        }
    }
    .quickUrl{
        display: flex;
        align-items: center;
        .left{
            flex: 0 0 150px;
        }
        .right{
            flex: 1;
            .right_flex{
                display: flex;
                align-items: center;

                .text-color-gray{
                    line-height: 18px
                }
            }
        }
    }
    .create_page_body{
        padding-right: 10px;
    }
</style>
<style>
.de-input-with-select{
    width: 600px;
}
.de-input-with-select .el-input-group__prepend {
    background-color: #fff;

}
.wide-confirm-box-15vh{
    vertical-align: top !important;
    margin-top: 15vh;
}
</style>
